import Carousel from "./Carousel";
import ProductCenter from "./ProductCenter";
import AboutUs from "./AboutUs";
import NewsTrands from "./NewsTrands";
import Excellent from "./Excellent";
import Cooperation from "./Cooperation";
export default {
  name: "Home",
  components: {
    Carousel,
    ProductCenter,
    AboutUs,
    NewsTrands,
    Excellent,
    Cooperation
  }
};